import { Table as TableUI } from '@mantine/core';
import { allCells } from '../../_cells';
import { useValues } from './TableCell.hooks';

export type TableCellProps = {
  field: ITableField;
  rowData: IModel;
};

export function TableCell(props: TableCellProps) {
  const { field, rowData } = props;
  const { id, cellType } = field;

  const Cmp = allCells[cellType];

  if (!Cmp) return <></>;

  const values = useValues(rowData, field);

  return (
    <TableUI.Td>
      <Cmp {...props} {...values} itemId={rowData.id} />
    </TableUI.Td>
  );
}

export default TableCell;
